import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  getCurrentUser,
  logout,
  refreshAuthSession,
} from "../../redux/features/auth/authSlice";

import { tokenStorage } from "../../utils/tokenStorage";
import PageLoader from "../ui/pageLoader/PageLoader";

export default function AuthBootstrap({ children }) {
  const dispatch = useDispatch();

  const { isBootstrapping } = useSelector((state) => state.auth);

  useEffect(() => {
    const bootstrapAuth = async () => {
      /**
       * NO SESSION
       */
      if (!tokenStorage.hasSession()) {
        return;
      }

      try {
        /**
         * VALIDATE ACCESS TOKEN
         */
        await dispatch(getCurrentUser()).unwrap();
      } catch (error) {
        /**
         * ACCESS TOKEN FAILED
         * TRY REFRESH
         */
        try {
          await dispatch(refreshAuthSession()).unwrap();

          /**
           * RETRY /ME
           */
          await dispatch(getCurrentUser()).unwrap();
        } catch (refreshError) {
          /**
           * SESSION INVALID
           */
          dispatch(logout());
        }
      }
    };

    bootstrapAuth();
  }, [dispatch]);

  /**
   * APP BOOTSTRAP LOADER
   */
  if (isBootstrapping) {
    return <PageLoader />;
  }

  return children;
}
